const en = {
  ID_CHAT_SIDE_SLIDE_PERSONAL_CHAT_TITLE: "Personal Chat",
  ID_CHAT_SIDE_SLIDE_CATEGORY_WORLD: "World",
  ID_CHAT_SIDE_SLIDE_CATEGORY_FOLLOWERS: "Follower",
  ID_CHAT_SIDE_SLIDE_CATEGORY_FOLLOWING: "Following",
  ID_CHAT_SIDE_SLIDE_START_CHAT: "Start",
};

export default en;
